import type { StoreApi } from "zustand";
import type {
  Attribute,
  AttributeCollection,
  AttributeCollectionId,
  AttributeGroup,
  AttributeGroupId,
  FieldId,
  FieldValueType,
} from "../../types";
import { findFieldById } from "../../utils/field-id";
import type { FormFieldUtilities, FormStore, SliceSetFunction } from "../types";

/**
 * ユーティリティスライスの作成
 * フォームのフィールド操作に関するユーティリティメソッドを提供
 */
export const createUtilitiesSlice = (
  _set: SliceSetFunction,
  get: () => FormStore,
  _store: StoreApi<FormStore>,
): FormFieldUtilities => ({
  getFieldValue: (fieldId: FieldId): FieldValueType | undefined => {
    const value = get().values.find((v) => v.fieldId === fieldId);
    return value?.value;
  },

  getAttribute: (fieldId: FieldId): Attribute | undefined => {
    const { form } = get();
    if (!form) return undefined;

    const field = findFieldById(form, fieldId);
    return field?.attribute;
  },

  getGroup: (groupId: AttributeGroupId): AttributeGroup | undefined => {
    const { form } = get();
    if (!form) return undefined;

    for (const collection of form.form.attributeCollections) {
      for (const group of collection.attributeGroupSettings) {
        if (group.id === groupId) {
          return group;
        }
      }
    }

    return undefined;
  },

  getCollection: (
    collectionId: AttributeCollectionId,
  ): AttributeCollection | undefined => {
    const { form } = get();
    if (!form) return undefined;

    for (const collection of form.form.attributeCollections) {
      if (collection.id === collectionId) {
        return collection;
      }
    }

    return undefined;
  },

  getFieldError: (fieldId: FieldId): string | null => {
    const error = get().errors.find((e) => e.fieldId === fieldId);
    return error ? error.message : null;
  },

  getTouched: (fieldId: FieldId): boolean => {
    return get().touched[fieldId] || false;
  },
});
